<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <!-- 小程序开发设置 -->
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("miniDevelopProgram.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_app_id") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_app_id"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_secret") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_secret"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_reply_qa_tid") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_reply_qa_tid"
                  :hint="$t('miniDevelopProgram.hint')"
                  single-line
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 公众号开发设置 -->
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("wechatOfficialSetting.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatOfficialSetting.app_id") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field v-model="app_id" single-line dense hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("wechatOfficialSetting.app_secret") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="app_secret"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 服务号开发设置 -->
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("wechatServiceSetting.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatServiceSetting.app_id") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_service_appid"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatServiceSetting.secret") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_service_secret"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatServiceSetting.newOrderNotice") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="settings.wechat_service_new_order_notice">
                  <v-radio :label="$t('BusinessSetting.RadioField.on')" :key="1" :value="1"/>
                  <v-radio :label="$t('BusinessSetting.RadioField.off')" :key="0" :value="0"/>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatServiceSetting.distributeNotice") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="settings.wechat_service_distribute_notice">
                  <v-radio :label="$t('BusinessSetting.RadioField.on')" :key="1" :value="1"/>
                  <v-radio :label="$t('BusinessSetting.RadioField.off')" :key="0" :value="0"/>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 右侧保存按钮 -->
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("miniDevelopProgram.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";

export default {
  data: () => ({
    settings: {},
    settingKeys: {
      keys: [
        "wechat_mini_app_id",
        "wechat_mini_secret",
        "wechat_mini_reply_qa_tid",
        "app_id",
        "timeStamp",
        "nonceStr",
        "signature",
        "wechat_service_appid",
        "wechat_service_secret",
        "wechat_service_new_order_notice",
        "wechat_service_distribute_notice",
      ]
    },
    serverErrors: [],
    wechat_official_setting: {},
    app_id: "",
    app_secret: "",
  }),
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.miniDevelopProgram"),
        disabled: true,
        href: "/settings/mini-develop-program",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getMiNiFromAPI();
  },
  methods: {
    getMiNiFromAPI() {
      Setting.getSettings(this.settingKeys).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            this.app_id = response.data.settings.wechat_official_setting
              ? response.data.settings.wechat_official_setting.app_id
              : "";
            this.app_secret = response.data.settings.wechat_official_setting
              ? response.data.settings.wechat_official_setting.app_secret
              : "";
            if (
              this.settings.wechat_service_new_order_notice == null ||
              typeof this.settings.wechat_service_new_order_notice == "undefined" ||
              this.settings.wechat_service_new_order_notice == undefined
            ) {
              //下单通知
              this.settings.wechat_service_new_order_notice = 0;
            }
            if (
              this.settings.wechat_service_distribute_notice == null ||
              typeof this.settings.wechat_service_distribute_notice == "undefined" ||
              this.settings.wechat_service_distribute_notice == undefined
            ) {
              //配送通知
              this.settings.wechat_service_distribute_notice = 0;
            }
          }
        }.bind(this)
      );
    },

    save() {
      delete this.settings.distribution_district_unique_enable;
      const arr = [];
      for (let key in this.settings) {
        arr.push({ setting_key: key, setting_value: this.settings[key] });
      }
      arr.push({
        setting_key: "wechat_official_setting",
        setting_value: {
          app_id: this.app_id,
          app_secret: this.app_secret,
        },
      });
      Setting.batchSave(arr).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
            this.getMiNiFromAPI();
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>